import bind from 'bind-decorator';

export class GridBasis
{
    private constructor(public readonly isFixedLength:boolean,
                        public readonly fixedLength:number,
                        public readonly stretchBasis:number)
    {}

    public static fixed(width:number)
    {
        return new GridBasis(true, width, NaN);
    }

    public static stretch(basis:number)
    {
        return new GridBasis(false, NaN, basis);
    }

    @bind
    toString()
    {
        return `[GridBasis isFixedLength:${this.isFixedLength} basis:${this.isFixedLength?this.fixedLength:this.stretchBasis}]`;
    }
}
